<template>
  <f7-page name="home" :ptr="true" @ptr:refresh="loadEvents">

    <!-- Top Navbar -->
    <f7-navbar :sliding="false" theme-dark>
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title class="text-align-center"></f7-nav-title>
      <f7-nav-right>
        <img src="static/logo_frekr.png" style="height: 1.8em;" />
        <f7-link :icon-material="syncError ? 'sync_problem' : 'sync'" popup-open="#popup-sync" />
      </f7-nav-right>
    </f7-navbar>

    <f7-popup id="popup-sync" swipe-to-close>
      <f7-page login-screen>
        <f7-navbar :title="'title:sync'|trans">
          <f7-nav-right>
            <f7-link popup-close>{{ 'nav:close'|trans }}</f7-link>
          </f7-nav-right>
        </f7-navbar>
        <f7-block>
          <h3 class="text-align-center">
            {{ 'label:last_sync'|trans }}: {{ eventsFetchedAt ? eventsFetchedAt.format('l LT') : '-' }}
          </h3>
          <p>{{ trans('info:online') }}</p>
          <f7-button fill @click="loadEvents(null, false, true)" icon-material="sync" :text="trans('btn:refresh')"/>
        </f7-block>
      </f7-page>
    </f7-popup>

    <f7-toolbar top v-if="authWarning" :inner="false" class="toolbar-auto-height text-align-center">
      <f7-block text-color="deeporange" class="block-low">
        <h3>
          <i class="fa fa-exclamation-circle"></i>
          {{ 'warning:authentication'|trans }}
          <f7-button fill small class="display-inline-block" color="deeporange" @click="showSettingsClearConfig()">
            <i class="fa fa-2x fa-cog"></i>
          </f7-button>
        </h3>
      </f7-block>
    </f7-toolbar>

    <!-- BOTTOM toolbar -->
    <f7-toolbar bottom :inner="false" no-shadow no-hairline class="toolbar-auto-height">
      <f7-block class="block-low">
        <f7-row>
          <f7-col v-for="btn in attendanceButtons" :key="btn.type" :width="btn.width">
            <f7-button fill large :color="btn.color" @click="attendancePopupShow(btn.type)">
              <i :class="['fa', 'fa-lg', btn.icon]"></i>
              <span class="hide-xs">{{ trans('btn:'+btn.type) }}</span>
            </f7-button>
          </f7-col>
        </f7-row>
      </f7-block>
    </f7-toolbar>

    <!-- ATTENDANCES list -->
    <f7-block class="attendance-status" role="status">
      <p>{{ trans('info:online') }}</p>
      <p>{{ trans('label:last_sync') }}: {{ eventsFetchedAt ? eventsFetchedAt.format('l LT') : '-' }}</p>
      <p v-if="syncError" class="text-color-red">{{ syncError }}</p>
      <f7-button @click="loadEvents(null, false, true)" :text="trans('btn:refresh')" />
    </f7-block>
    <f7-block-header>
      <f7-row>
        <f7-col class="text-align-left">{{ preferences.getCompany().name }}</f7-col>
        <f7-col class="text-align-right">{{ preferences.getUser().name }}</f7-col>
      </f7-row>
    </f7-block-header>
    <f7-block v-if="events && !events.length">{{ trans('info:empty') }}</f7-block>
    <f7-list accordion-list class="smaller-xs">
      <f7-list-item accordion-item v-for="(evt,key) in events" :title="printDateTime(evt.created_at)" :key="evt.created_at">
        <span slot="media" class="center-fill">
          <f7-icon :icon="getClasses(evt, key).join(' ')" :tooltip="trans('tip:'+evt.event_type)"/>
        </span>
        <span slot="after" style="opacity: 0.8">
          <f7-icon icon="fa fa-lg fa-comment"    v-if="evt.comment"           :tooltip="evt.comment"          />&nbsp;
          <f7-icon icon="fa fa-lg fa-exchange"   v-if="evt.is_modified"       :tooltip="'tip:modified'|trans" />&nbsp;
          <f7-icon icon="fa fa-lg fa-map-marker" v-visible="evt.hasLocation()":tooltip="'tip:location'|trans" />&nbsp;
          <f7-icon icon="fa fa-lg fa-tag"        v-visible="evt.tag"          :tooltip="evt.tag ? evt.tag.text : null"
              :style="{color: (evt.tag && evt.tag.color) ? evt.tag.color : 'inherit'}" /> &nbsp;
          <!--f7-icon icon="fa fa-lg fa-magic"    :tooltip="'tip:automatic'|trans" v-visible="evt.is_automatic" /-->
        </span>
        <f7-accordion-content>
          <f7-block inset>
            <p>
              <b>{{ trans(':'+evt.event_type) }}</b>&nbsp;
              <i class="fa fa-clock-o"></i>&nbsp; {{ printDateTime(evt.created_at, 'long') }}
            </p>
            <p v-if="evt.tag">
              <i class="fa fa-lg fa-tag" :style="{color: (evt.tag && evt.tag.color) ? evt.tag.color : 'inherit'}"></i>&nbsp;
              {{ evt.tag.text }}
            </p>
            <template v-if="evt.hasLocation()">
              <p class="centered">
                <i class="fa fa-lg fa-map-marker"></i>&nbsp;
                {{ ':geo:lat' |trans }}: {{ evt.latitude .toFixed(4) }},
                {{ ':geo:long'|trans }}: {{ evt.longitude.toFixed(4) }},&nbsp;
              </p>
              <p><f7-link external :href="evt|mapUrl" target="_blank" icon="fa fa-map" :text="':geo:show'|trans" /></p>
            </template>
            <p v-if="evt.comment"><i class="fa fa-comment"></i>&nbsp; {{ evt.comment }}</p>
          </f7-block>
        </f7-accordion-content>
      </f7-list-item>
    </f7-list>
    <div class="attendance-bottom-space"></div>

    <!-- SUBMIT ATTENDANCE popup -->
    <f7-popup :opened="attendancePopupOpened" @popup:close="attendancePopupClosed" swipe-to-close swipe-handler=".swipe-handler">
      <f7-page>

        <!-- TITLE, close button -->
        <f7-navbar :title="trans('title:new:'+newAttendanceType)" class="swipe-handler">
          <f7-nav-right>
            <f7-link popup-close>{{ 'nav:close'|trans }}</f7-link>
          </f7-nav-right>
        </f7-navbar>

        <!-- TAGS list -->
        <f7-list>
          <f7-list-item v-for="tag in tagsArray" :title="tag.text" @click="submitAttendance(tag)" link="#"
              :key="''+tag.color+tag.text">
            <span slot="media" class="center-fill">
              <i class="fa fa-tag" :style="{'color': tag.color ? tag.color : '#999999'}"></i>
            </span>
          </f7-list-item>
        </f7-list>

        <!-- SUBMIT/CANCEL buttons -->
        <f7-toolbar bottom :inner="false" no-shadow no-hairline class="toolbar-auto-height">
          <f7-block class="block-low">
            <!-- comment box -->
            <f7-input :placeholder="trans('placeholder:comment')" :value="newAttendanceComment" @focus="submitTimeout = 0"
                @input="newAttendanceComment = $event.target.value" type="text" />
            <br />
            <f7-row>
              <f7-col>
                <f7-button fill large color="green" @click="submitAttendance(null)">
                  <i :class="['hide-xs', 'fa', 'fa-2x', getIcon(newAttendanceType)]"></i>
                  <span>{{ trans('btn:'+newAttendanceType) + submitTimeoutStr }}</span>
                </f7-button>
              </f7-col>
              <f7-col>
                <f7-button fill large color="red" popup-close>
                  <span>{{ 'btn:cancel'|trans }}</span>
                </f7-button>
              </f7-col>
            </f7-row>
          </f7-block>
        </f7-toolbar>

      </f7-page>
    </f7-popup>

  </f7-page>

</template>
<script>
  import Geolocation from '../js/geolocation.js';
  import Preferences from '../js/preferences.js';
  import RequestManager from '../js/request-manager.js';
  import EventBus, * as EventBus_ from '../js/event-bus.js';

  import Settings, * as Settings_ from '../components/settings.vue';

  import moment from 'moment';

  moment.locale(navigator.language);

  export default {
    data() {
      return {
        attendanceButtons: [
          {type: 'login',  width: '35', icon: 'fa-sign-in',  color: 'green'},
          {type: 'log',    width: '30', icon: 'fa-info',     color: 'gray'},
          {type: 'Logout', width: '35', icon: 'fa-sign-out', color: 'red'}
        ],
        events: null,
        eventsFetchedAt: null,
        attendancePopupOpened: false,
        syncError: null,
        newAttendanceType: 'log',
        newAttendanceComment: null,
        submitTimeout: 0,
        submitting: false,
        tags: { shared: null, own: null },
        authWarning: false
      };
    },
    methods: {
      showSettingsClearConfig() {
        EventBus.$emit(Settings_.SHOW, Settings_.dialogs.CLEAR_CONFIG);
      },
      printDateTime(t, format) {
        if (typeof format == 'undefined') format = 'short';
        switch (format) {
          case 'short': return moment(t).format('L LT');
          case 'long': return moment(t).format('LL LTS');
          default:
            console.error('unknown time format `'+format+"'");
            return 'error';
        }
      },
      getIcon: function(event_type) {
        switch (event_type) {
          case 'login': return 'fa-sign-in';
          case 'Logout': return 'fa-sign-out';
          case 'log': return 'fa-info';
        }
      },
      getClasses(evt, key) {
        var ret = ['fa', 'fa-fw']
        switch (evt.event_type) {
          case 'login':
            ret.push('fa-sign-in');
            ret.push('text-color-green');
            break;
          case 'Logout':
            ret.push('fa-sign-out');
            ret.push('text-color-red');
            break;
          case 'log':
            ret.push('fa-info');
            ret.push('text-color-purple');
            break;
          default:
            console.error("Attendance event: unknown type `"+evt.event_type+"'");
            return {};
        }
        ret.push('fa-lg');
        return ret;
      },
      loadEvents: function(done, doInBackground, showSpinner) {
        if (typeof doInBackground === 'undefined') doInBackground = false;
        if (typeof showSpinner === 'undefined') showSpinner = false;
        var self = this;
        if (!doInBackground) {
          if (showSpinner) this.$f7.dialog.preloader();
          RequestManager.getEvents(
            function(events) {
              if (showSpinner) this.$f7.dialog.close();
              if (done) done();
            }.bind(self),
            function(xhr) {
              if (showSpinner) this.$f7.dialog.close();
              if (done) done();
              this.$f7.dialog.alert(this.trans('err:sync:'+((xhr.status/100)|0)));
            }.bind(self)
          );
        } else RequestManager.getEvents();
      },
      attendancePopupShow: function(type) {
        var tags = Preferences.getTags();
        if (tags !== null) this.tags = tags;
        this.newAttendanceComment = null;
        this.newAttendanceType = type;
        this.submitTimeout = 6;
        this.attendanceTimeoutCB();
        this.attendancePopupOpened = true;
      },
      attendanceTimeoutCB: function() {
        if (this.submitTimeout <= 0) return;
        this.submitTimeout -= 1;
        if (this.submitTimeout > 0) window.setTimeout(this.attendanceTimeoutCB, 1000);
        else this.submitAttendance();
      },
      attendancePopupClosed: function() {
        this.submitTimeout = 0;
        this.attendancePopupOpened = false;
      },
      submitAttendance: function(tag) {
        if (this.submitting) return;
        this.submitting = true;
        this.submitTimeout = 0;
        var self = this;
        this.$f7.dialog.preloader();
        var attendance = {
          createdAt: moment().format(),
          event_type: this.newAttendanceType,
          employee_id: Preferences.getUser().id,
          comment: this.newAttendanceComment,
          tag: tag
        };

        var submitSuccess = function(xhr) {
          // FIXME: the /api/longentries endpoint works asynchronously (via push notifications)
          //   as a hack, I'm waiting 2 seconds before fetching the new events
          //   to fix this, a synchronous api endpoint should be added, or push notifs should be used here
          window.setTimeout(function() {
            this.$f7.dialog.close();
            this.submitting = false;
            this.attendancePopupOpened = false;
            this.loadEvents(null, true);
            this.$f7.dialog.alert(this.trans('info:accepted'));
          }.bind(self), 2000);
        }.bind(self);
        var submitFailure = function(xhr) {
          this.submitting = false;
          this.$f7.dialog.close();
          this.$f7.dialog.alert(this.trans('err:submit'));
        }.bind(self);

        if (Preferences.getGeolocationEnabled()) {
          Geolocation.getCurrentPosition(function(coords) {
            Object.assign(attendance, coords);
            RequestManager.submitAttendance(attendance, submitSuccess, submitFailure);
          }.bind(self), function(error) {
            this.$f7.dialog.close();
            this.$f7.dialog.confirm(this.trans('confirm:geoerr_continue'), null, function() {
              this.$f7.dialog.preloader();
              RequestManager.submitAttendance(attendance, submitSuccess, submitFailure);
            }.bind(self), function() { this.submitting = false; }.bind(self));
          }.bind(self));
        } else RequestManager.submitAttendance(attendance, submitSuccess, submitFailure);
      },
      tagCompare: function(a, b) {
        if (a.text < b.text) return -1;
        else if (a.text > b.text) return 1;
        else return 0;
      },
      eventsLoaded: function(events) {
        this.authWarning = false;
        this.syncError = false;
        this.events = events;
        this.eventsFetchedAt = moment();
      },
    },
    computed: {
      tagsArray: function() {
        var tags = this.tags;
        var ret = [];
        if (tags === null) return ret;
        if (tags.own !== null) {
          tags.own.sort(this.tagCompare);
          ret = ret.concat(tags.own);
        }
        if (tags.shared !== null) {
          tags.shared.sort(this.tagCompare);
          ret = ret.concat(tags.shared);
        }
        return ret;
      },
      submitTimeoutStr: function() {
        if (this.submitTimeout > 0) return ' ('+(this.submitTimeout|0)+')';
        else return '';
      }
    },
    mounted: function() {
      var self = this;

      this.registerOn     (EventBus, RequestManager.EVENTS_LOADED, this.eventsLoaded);
      this.registerOnError(EventBus, RequestManager.EVENTS_LOADED, xhr => this.syncError = this.trans('err:sync:'+((xhr.status/100)|0)));
      this.registerOn     (EventBus, RequestManager.AUTH_ERROR,    () => this.authWarning = true);
      this.registerOn     (EventBus, EventBus_.WINDOW_FOCUS,       () => this.loadEvents(null, true));

      this.events = Preferences.getAttendances();
      this.eventsFetchedAt = Preferences.getAttendanesFetchedAt();

      this.loadEvents(null, true);
      RequestManager.getTags();
    },
  }
</script>
